export const isExternalLink = (link: string) => {
  return link.startsWith('https://');
};
export const isInternalLink = (link: string) => link.startsWith('/');

export const isInternalActionLink = (link: string) => link.startsWith('/?');
